export interface PrincipleItem {
  id: string;
  icon: string;
  title: string;
  desc: string;
}

export const principles: PrincipleItem[] = [
  {
    id: 'p1',
    icon: 'ri-focus-3-line',
    title: '只呈现事实分层',
    desc: '我们将"已确认事实""多方佐证""单方说法""网络猜测"严格区分，绝不把传闻包装成结论。',
  },
  {
    id: 'p2',
    icon: 'ri-route-line',
    title: '坚持还原时间顺序',
    desc: '一切细节都放回时间轴上，优先呈现先后次序与发布语境，避免断章取义造成的误解。',
  },
  {
    id: 'p3',
    icon: 'ri-refresh-line',
    title: '持续跟踪纠偏',
    desc: '事件有新进展就及时更新，发现旧信息有误就主动标注勘误，让时间线始终可信、可用。',
  },
  {
    id: 'p4',
    icon: 'ri-archive-2-line',
    title: '沉淀而非消耗',
    desc: '我们不追一时热度，而是把碎片化信息沉淀为可回溯的档案，让后来者一次看懂前因后果。',
  },
];

export interface UpdateItem {
  id: string;
  date: string;
  time: string;
  title: string;
  type: string;
}

export const updateFeeds: UpdateItem[] = [
  { id: 'u1', date: '2025.06.18', time: '14:20', title: '官方说明发布，早期部分存疑表述已修订', type: '重大更新' },
  { id: 'u2', date: '2025.06.15', time: '09:02', title: '新增两条独立渠道的交叉佐证信息', type: '补充佐证' },
  { id: 'u3', date: '2025.06.11', time: '20:45', title: '针对流传截图增加语境说明与勘误提示', type: '勘误' },
  { id: 'u4', date: '2025.06.07', time: '17:30', title: '事件时间线整体重排，补齐前期空白节点', type: '结构优化' },
];